module.exports = __webpack_public_path__ + "media/gif.eb030016.webm";